import { Box } from '@chakra-ui/react'
import { css } from '@emotion/react'
// ESLint complains that we're importing directly from a JS file.
// eslint-disable-next-line
import renderMathInElement from 'katex/dist/contrib/auto-render.js'
import 'katex/dist/katex.min.css'
import React, { type ReactElement, type ReactNode } from 'react'

export default function LatexContainer({ children }: { children: ReactNode }): ReactElement {
  const ref = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (ref.current == null) {
      return
    }
    renderMathInElement(ref.current, {
      delimiters: [
        { left: '$$$', right: '$$$', display: true },
        { left: '$$', right: '$$', display: false },
        { left: '\\(', right: '\\)', display: false },
        { left: '\\[', right: '\\]', display: true },
      ],
      throwOnError: false,
    })
  })

  return (
    <Box
      ref={ref}
      css={css`
        .katex {
          max-width: 100%;
          overflow-x: scroll;
        }
      `}
    >
      {children}
    </Box>
  )
}
